import { makeStyles } from '@material-ui/styles'
import { getOutlinedTextFieldWrapperStyles } from 'lib/form-field-styles'

export const useStyles = makeStyles(theme => ({
  dialogPaper: {
    borderRadius: 12,
    overflow: 'hidden',
  },
  titleRoot: {
    padding: theme.spacing(3, 7, 0.5, 3),
  },
  dialogContent: {
    display: 'flex',
    flexDirection: 'column',
    gap: theme.spacing(2),
    padding: theme.spacing(0, 3, 2),
  },
  dialogActions: {
    padding: theme.spacing(2, 3, 3),
    gap: theme.spacing(1),
    justifyContent: 'flex-end',
  },
  ageTiles: {
    marginBottom: 0,
  },
  fieldLabel: {
    fontWeight: 700,
    fontSize: '0.9375rem',
    lineHeight: 1.3,
    color: '#00205B',
    marginBottom: theme.spacing(1.5),
  },
  ageChoiceGroup: {
    border: '1px solid #E0E0E0',
    borderRadius: 12,
    backgroundColor: '#FFFFFF',
    overflow: 'hidden',
    width: '100%',
  },
  ageChoiceDivider: {
    backgroundColor: '#E0E0E0',
  },
  ageChoiceCard: {
    display: 'flex',
    alignItems: 'center',
    gap: theme.spacing(2),
    padding: theme.spacing(2.5, 3),
    boxSizing: 'border-box',
    width: '100%',
    border: 'none',
    margin: 0,
    background: 'transparent',
    cursor: 'pointer',
    textAlign: 'left',
    font: 'inherit',
    color: 'inherit',
    '&:hover': {
      backgroundColor: '#FAFBFC',
    },
    [theme.breakpoints.down('xs')]: {
      padding: theme.spacing(1.75, 2),
      gap: theme.spacing(1.5),
    },
  },
  ageChoiceIcon: {
    width: 32,
    height: 32,
    flexShrink: 0,
    borderRadius: '50%',
    backgroundColor: '#EBF0F2',
    color: '#172024',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    '& .MuiSvgIcon-root': {
      fontSize: 16,
    },
    '& svg': {
      width: 16,
      height: 16,
    },
  },
  ageChoiceBody: {
    flex: 1,
    minWidth: 0,
  },
  ageChoiceTitle: {
    margin: 0,
    fontSize: '0.9375rem',
    fontWeight: 600,
    lineHeight: 1.3,
    color: '#172024',
  },
  ageChoiceDescription: {
    margin: theme.spacing(0.5, 0, 0),
    fontSize: '0.8125rem',
    lineHeight: 1.4,
    color: theme.palette.text.secondary,
  },
  ageChoiceRadioRoot: {
    flexShrink: 0,
    padding: theme.spacing(0.5),
    color: '#40484C',
    pointerEvents: 'none',
  },
  ageChoiceRadioChecked: {
    color: '#0053FF',
  },
  fieldRow: {
    display: 'grid',
    gridTemplateColumns: 'repeat(2, minmax(0, 1fr))',
    gap: theme.spacing(2),
    [theme.breakpoints.down('xs')]: {
      gridTemplateColumns: '1fr',
      gap: theme.spacing(1.5),
    },
  },
  fieldStack: {
    display: 'flex',
    flexDirection: 'column',
    gap: theme.spacing(2),
  },
  formField: {
    ...getOutlinedTextFieldWrapperStyles(theme),
    margin: 0,
  },
  sectionLabel: {
    fontSize: '0.6875rem',
    fontWeight: 600,
    letterSpacing: '0.08em',
    lineHeight: 1.3,
    textTransform: 'uppercase',
    color: '#6B7C87',
  },
  wrappedNameFields: {
    display: 'flex',
    [theme.breakpoints.down('sm')]: {
      flexDirection: 'column',
    },
  },
  sectionHeader: {
    textTransform: 'uppercase',
    fontWeight: '500',
    fontSize: '12px',
    marginTop: '15px',
  },
}))
